import { useRouter } from 'next/router'
import useSWR from 'swr'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import { TEMPLATES_API } from '../api/templates-api'
import { TemplatesCategoryInterface } from '../types/templates-category-interface'

export const useTemplateCategories = () => {
  const { locale, isReady } = useRouter()
  const fetcherWithErrorValidation = useApiWrapperWithErrorValidation<
    RequestMethodsEnum.get,
    TemplatesCategoryInterface[]
  >({ method: RequestMethodsEnum.get })
  return useSWR<TemplatesCategoryInterface[]>(() => {
    if (!isReady || !locale) return null
    return `${TEMPLATES_API}/filter/categories/${locale}`
  }, fetcherWithErrorValidation)
}
